module.exports = __webpack_public_path__ + "img/clere-hub-only.371ba4fe.png";